import { CLOUD_FUNCTION_URL_EUW2 } from '../../env';

/**
 * Sends an http request to the sendPasswordResetEmail Cloud Run function.
 * @param email Target email.
 */
export const requestPasswordReset = async (email: string): Promise<void> => {
  const response = await fetch(`${CLOUD_FUNCTION_URL_EUW2}/sendPasswordResetEmail`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      metadata: { source: 'requestPasswordReset' },
      data: { params: { email } }
    })
  });
  if (!response.ok) {
    throw new Error(`sendPasswordResetEmail responded with status ${response.status}`);
  }
};
